import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { ProductFavoriteResponse } from 'src/app/models/product-favorite.model';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { UserSaved } from 'src/app/models/user.model';

import { ProductFavoriteService } from 'src/app/services/product-favorite.service';
import { ProductService } from 'src/app/services/product.service';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { AuthenticationService } from '../../../authentication/authentication/authentication.service';

@Component({
    selector: 'app-products-favorites',
    templateUrl: './products-favorites.component.html',
    styleUrls: ['./products-favorites.component.scss']
})
export class ProductsFavoritesComponent implements OnInit {

    favorites: ProductFavoriteResponse[] = [];

    warehouses: WarehouseResponse[] = [];
    warehouse: number = null;

    user: UserSaved = null;

    filterWord: string = "";

    loading = false;

    deleting: { [key: number]: boolean } = {};
    seeing: { [key: number]: boolean } = {};

    categories: { [key: number]: string } = {};

    pagination = {
        total: [],
        filter: [],
        pageSize: 5,
        startElement: 0,
        lastElement: 0,
        pageIndex: 0
    };

    constructor(
        private toastService: ToastrService,
        private productFavoriteService: ProductFavoriteService,
        private warehouseService: WarehouseService,
        private productService: ProductService,
        private authService: AuthenticationService
    ) {
        this.user = this.authService.getUser();
    }

    ngOnInit(): void {
        this.getProductCategories();
        this.getWarehousesByUser();
    }

    getWarehousesByUser() {

        this.warehouseService
            .getWarehousesAllowedByUser(this.user.id)
            .subscribe({
                next: (response: ResponseObject) => {
                    if (response.data.length > 0) {
                        this.warehouses = response.data;

                        if (this.warehouses.length === 1) {
                            this.warehouse = this.warehouses[0].id;
                            this.getFavorites();
                        }
                    } else {
                        this.getWarehouses();
                    }
                },
                error: (error: HttpErrorResponse) => {
                    this.toastService.error(
                        error.error.message
                    );
                }
            });
    }

    getWarehouses() {

        this.warehouseService
            .getWarehouseByClue('')
            .subscribe({
                next: (response: ResponseObject) => {
                    this.warehouses = response.data;
                    if (this.warehouses.length === 1) {
                        this.warehouse = this.warehouses[0].id;
                        this.getFavorites();
                    }
                },
                error: (error: HttpErrorResponse) => {
                    this.toastService.error(
                        error.error.message
                    );
                }
            });
    }

    changeWarehouse() {
        this.filterWord = "";
        if (this.warehouse == null) {

            this.favorites = [];
            this.pagination.total = [];
            this.resetPagination();

            return;
        }
        this.getFavorites();
    }

    getFavorites() {
        if (this.warehouse == null) {
            return;
        }
        this.loading = true;

        this.productFavoriteService
            .getByWarehouse(this.warehouse)
            .subscribe({
                next: (response: ResponseObject) => {
                    const data = Array.isArray(response.data) ? response.data as ProductFavoriteResponse[] : [];
                    this.favorites = data.filter(
                        favorite => favorite && favorite.product
                    );

                    this.favorites.forEach(favorite => {

                        favorite.product['family'] =
                            this.categories[
                                favorite.product.parentCategory
                            ] || null;
                    });

                    this.setPagination(this.favorites);

                    this.loading = false;
                },

                error: (error: HttpErrorResponse) => {

                    this.loading = false;

                    this.toastService.error( error.error?.message || "Error al obtener los productos favoritos" );
                }
            });
    }

    getProductCategories() {
        this.productService.getCatalogs().subscribe({
            next: (response: ResponseObject) => {
                const productCategories = response.data.productCategories;

                productCategories.forEach(category => {
                    this.categories[category.id] = category.name;
                });

            },
            error: (error: HttpErrorResponse) => {
                console.error(
                    "Error al obtener categorías",
                    error
                );
            }
        });
    }

    filter() {

        const value = (this.filterWord || "").trim().toLowerCase();
        if (!value) {

            this.pagination.total = [
                ...this.favorites
            ];

            this.resetPagination();

            return;
        }

        this.pagination.total = 
            this.favorites.filter(favorite => {
                const product = favorite?.product;

                if (!product) {
                    return false;
                }

                const code = (product.code || "").toLowerCase();
                const barCode = (product.barCode || "").toLowerCase()
                const name = (product.name || "").toLowerCase();

                return (
                    code.includes(value) ||
                    barCode.includes(value) ||
                    name.includes(value)
                );
            });

        this.resetPagination();
    }

    deleteFavorite(
        favorite: ProductFavoriteResponse
    ) {

        if (this.deleting[favorite.id]) {
            return;
        }

        this.deleting[favorite.id] = true;

        this.productFavoriteService
            .delete(favorite.id)
            .subscribe({
                next: () => {

                    this.deleting[favorite.id] = false;

                    this.toastService.success(
                        "Producto eliminado de favoritos correctamente"
                    );

                    this.getFavorites();
                },
                error: (error: HttpErrorResponse) => {

                    this.deleting[favorite.id] = false;

                    this.toastService.error(
                        error.error.message ||
                        "Error al eliminar el producto de favoritos"
                    );
                }
            });
    }

    resetPagination() {
        this.pagination = {
            ...this.pagination,

            filter: this.pagination.total.slice(
                0,
                this.pagination.pageSize
            ),

            pageIndex: 0,

            startElement: 0,

            lastElement: Math.min(
                this.pagination.pageSize,
                this.pagination.total.length
            )
        };
    }

    setPagination(elements: ProductFavoriteResponse[]) {

        this.pagination = {
            total: [...elements],
            filter: elements.slice(0, 5),
            pageSize: 5,
            startElement: 0,
            lastElement: Math.min(5, elements.length),
            pageIndex: 0
        };
    }
}